import React, { useEffect, useState } from "react";
import { FaCheck, FaPen, FaTimes, FaWeight } from "react-icons/fa";

import { formatWeight } from "../utils/peseeUtils";

const InlineWeightEditor = ({ value, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!editing) {
      setDraft(value ?? "");
    }
  }, [value, editing]);

  const displayed = formatWeight(value);

  const save = async () => {
    setSaving(true);

    try {
      const ok = await onSave?.(draft);

      if (ok !== false) {
        setEditing(false);
      }
    } finally {
      setSaving(false);
    }
  };

  const cancel = () => {
    setDraft(value ?? "");
    setEditing(false);
  };

  if (!editing) {
    return (
      <button
        type="button"
        onClick={() => setEditing(true)}
        className={`
          inline-flex min-h-10 w-full items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-bold transition
          ${
            displayed
              ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200 hover:bg-emerald-100 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-400/20"
              : "bg-orange-50 text-orange-700 ring-1 ring-orange-200 hover:bg-orange-100 dark:bg-orange-500/10 dark:text-orange-300 dark:ring-orange-400/20"
          }
        `}
        title={displayed ? "Modifier le poids" : "Saisir le poids"}
      >
        {displayed ? <FaPen className="h-3 w-3" /> : <FaWeight className="h-4 w-4" />}
        {displayed ? `${displayed} kg` : "Peser"}
      </button>
    );
  }

  return (
    <div className="flex min-w-[210px] items-center gap-2">
      <input
        type="text"
        inputMode="decimal"
        value={draft ?? ""}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") save();
          if (event.key === "Escape") cancel();
        }}
        className="
          h-10 w-24 rounded-xl border border-slate-300 bg-white px-3 text-sm font-bold text-slate-900
          outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-200
          dark:border-white/10 dark:bg-slate-900 dark:text-white dark:focus:ring-orange-500/20
        "
        placeholder="40,1"
        autoFocus
      />

      <button
        type="button"
        onClick={save}
        disabled={saving}
        className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-600 text-white transition hover:bg-emerald-700 disabled:opacity-60"
        title="Enregistrer"
      >
        <FaCheck className="h-3.5 w-3.5" />
      </button>

      <button
        type="button"
        onClick={cancel}
        disabled={saving}
        className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-slate-700 transition hover:bg-slate-200 disabled:opacity-60 dark:bg-slate-800 dark:text-white dark:hover:bg-slate-700"
        title="Annuler"
      >
        <FaTimes className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default InlineWeightEditor;